module.exports = __webpack_public_path__ + "img/jcyj.79ce53ee.png";